import React from "react";
import Avatar from "components/Avatar/Avatar";
import { sortExpertsByNumeration } from "utils/sort-experts";

export default function renderExperts(rawExperts, noTitle) {
  const experts = sortExpertsByNumeration(rawExperts);

  return experts && experts.length ? (
    <div className=" l2 experts">
      {experts.map((expert) => (
        <div
          key={`previous_webinars_expert_${expert.id}`}
          className="flex_row expert_table_item"
        >
          <div className="section_photo mr-10">
            <Avatar
              size={55}
              name={expert.name}
              src={expert.expert_avatar_url}
            />
          </div>
          <div>
            {expert.name && expert.name != "null" ? (
              <p className="section_name">{expert.name}</p>
            ) : null}
            <p className="section_post">
              {expert.expert_type && expert.expert_type != "null"
                ? expert.expert_type
                : null}
              <br />
              {expert.location && expert.location != "null"
                ? expert.location
                : null}
              <br />
              {!noTitle && expert.presentation_title}
              <br />
            </p>
          </div>
        </div>
      ))}
    </div>
  ) : null;
}



// WEBPACK FOOTER //
// ./src/components/Dashboard/renderExperts.js